import { deleteSettingsServiceApi as generatedDeleteSettingsServiceApi } from '../generated/settingsServices/deleteSettingsService';

const deleteSettingsServiceApi = generatedDeleteSettingsServiceApi.enhanceEndpoints({
  endpoints: {
    deleteSettingsService: {
      invalidatesTags: (_result, _error, { serviceId }) => [{ id: serviceId, type: 'Services' }, 'Services'],
    },
  },
});

export const { useDeleteSettingsServiceMutation } = deleteSettingsServiceApi;
